import { IconNames } from './icon-names';

export enum TruckSize {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
}

export enum ExtendedTruckSize {
  XX = 'XX',
  ST = 'ST',
}

export type TruckSizeUnion = TruckSize | ExtendedTruckSize;

export const TRUCK_SIZE_ICONS = new Map<TruckSizeUnion, IconNames>([
  [TruckSize.S, IconNames.TruckSizeS],
  [TruckSize.M, IconNames.TruckSizeM],
  [TruckSize.L, IconNames.TruckSizeL],
  [TruckSize.XL, IconNames.TruckSizeXL],
  [TruckSize.XXL, IconNames.TruckSizeXXL],
  [ExtendedTruckSize.XX, IconNames.TruckSizeXX],
  [ExtendedTruckSize.ST, IconNames.TruckSizeST],
]);

export enum TruckType {
  TRUCK = 'Truck',
  TRAILER = 'Trailer',
}
